import * as React from "react";
import type { SVGProps } from "react";
const SvgDinersClub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#0069aa"
      fillRule="evenodd"
      d="M15.755 11.629a5.02 5.02 0 0 0-3.222-4.682v9.363a5.02 5.02 0 0 0 3.222-4.681m-6.813 4.68v-9.36a5.025 5.025 0 0 0-3.22 4.68 5.02 5.02 0 0 0 3.22 4.68M10.74 3.715a7.914 7.914 0 0 0-7.913 7.914 7.913 7.913 0 1 0 7.912-7.914m-.02 16.573C5.936 20.31 2 16.436 2 11.719 2 6.565 5.936 3 10.72 3h2.24C17.687 3 22 6.563 22 11.72c0 4.714-4.313 8.568-9.04 8.568z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDinersClub;
